import SuccessIcon from "../../assets/svg/success-icon";
import PendingIcon from "../../assets/svg/pending-icon";
import { Separator } from "../separator";
import { Helpers } from "../../utils/helper";
import useIsMobile from "../../hooks/use-is-mobile";
import { OwnerConsentStatus } from "../../models/polymer/ConsentApplication.model";
import { PolymerCrypto } from "../../utils/encryptor";
import { EligibilityCheck } from "../../models/classes/EligibilityOverride.class";
interface GatherTableContentProps {
  children: OwnerConsentStatus[],
  uinfinsToBypass: string[]
}

const GatherTableContent = ({ children, uinfinsToBypass }: GatherTableContentProps) => {
  const { isMobile } = useIsMobile();

  function getText(isNotRequired: boolean, consentStatus: OwnerConsentStatus) {
    if (isNotRequired) {
      return "Consent is not required"
    }

    if (consentStatus.consent_given_date?.length > 0) {
      return `Consent was given on ${Helpers.formatDate(
        consentStatus.consent_given_date
      )}`
    }

    return "Awaiting consent"
  }

  return (
    <>
      {children.map((item, index) => {
        const key = index;
        const decryptedUinfin = PolymerCrypto.decryption(item.uin_fin);
        const isNotRequired = item.consent_check === EligibilityCheck.EXEMPT || uinfinsToBypass.includes(decryptedUinfin);

        return (
          <div key={key}>
            <div
              className="polymer-gather-consent-items-container"
              key={item.owner_name}
            >
              <div className="polymer-gather-consent-items-left">
                <p className="polymer-gather-consent-items polymer-gather-consent-items-text polymer-gather-consent-items-name">
                  {item.owner_name}
                </p>
                {!isMobile && (
                  <div className="polymer-gather-consent-items">
                    {(isNotRequired || item.consent_given) ? <SuccessIcon /> : <PendingIcon />}
                  </div>
                )}
              </div>
              <div className="d-flex gap-2 polymer-gather-consent-items polymer-gather-consent-items-text polymer-gather-consent-items-date">
                {" "}
                {isMobile && (
                  <div className="polymer-gather-consent-items">
                    {(isNotRequired || item.consent_given) ? <SuccessIcon /> : <PendingIcon />}
                  </div>
                )}{" "}
                
                <p>{getText(isNotRequired, item)}</p>

              </div>
            </div>
            {index !== children.length - 1 && <Separator />}
          </div>
        );
      })}
    </>
  );
};

export default GatherTableContent;
